import { defineComponent, computed, openBlock, createBlock, resolveDynamicComponent, unref, normalizeClass, withCtx, createElementVNode, renderSlot } from "vue";
import { p as pick } from "../../../vendor.js";
import { u as useRouterLinkProps, a as useRouterLink } from "../../composables/useRouterLink.js";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset.js";
import { u as useBem } from "../../composables/useBem.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaListItem"
  },
  __name: "VaListItem",
  props: {
    ...useRouterLinkProps,
    ...useComponentPresetProp,
    tag: { type: String, default: "div" },
    disabled: { type: Boolean, default: false }
  },
  emits: ["focus", "click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const tabIndexComputed = computed(() => props.disabled ? -1 : 0);
    const computedClass = useBem("va-list-item", () => ({
      ...pick(props, ["disabled"])
    }));
    const {
      tagComputed,
      hrefComputed
    } = useRouterLink(props);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(tagComputed)), {
        class: normalizeClass(["va-list-item", unref(computedClass)]),
        role: "listitem",
        href: unref(hrefComputed),
        target: _ctx.target,
        to: _ctx.to,
        replace: _ctx.replace,
        exact: _ctx.exact,
        "active-class": _ctx.activeClass,
        "exact-active-class": _ctx.exactActiveClass,
        tabindex: tabIndexComputed.value
      }, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: "va-list-item__inner",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click")),
            onFocus: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("focus"))
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 32)
        ]),
        _: 3
      }, 8, ["href", "target", "to", "replace", "exact", "active-class", "exact-active-class", "class", "tabindex"]);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaListItem.css';
//# sourceMappingURL=VaListItem.vue_vue_type_script_setup_true_lang.js.map
